import { render } from "./PlanTransportGroupResultScheme3D.vue?vue&type=template&id=3d9f2fae&scoped=true&ts=true"
import script from "./PlanTransportGroupResultScheme3D.vue?vue&type=script&lang=ts"
export * from "./PlanTransportGroupResultScheme3D.vue?vue&type=script&lang=ts"

import "./PlanTransportGroupResultScheme3D.vue?vue&type=style&index=0&id=3d9f2fae&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\2f08168a1cda37d3\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d9f2fae"]])

export default __exports__